import React, { useState, useEffect } from 'react';
import { Button, Form, Modal, Table, Card, Row, Col, Pagination } from 'react-bootstrap';
import axios from 'axios';
import { FaEdit } from 'react-icons/fa';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';


const baseURL = 'https://vyaparapi.emedha.in/api/seller/products'; // Update as needed

const Products = () => {
  const user = JSON.parse(sessionStorage.getItem('user'));
  const userId = user?.id;


const [searchQuery, setSearchQuery] = useState('');
const [currentPage, setCurrentPage] = useState(1);
const itemsPerPage = 5;



const indexOfLastItem = currentPage * itemsPerPage;
const indexOfFirstItem = indexOfLastItem - itemsPerPage;



  const [products, setProducts] = useState([]);
  const [formData, setFormData] = useState({
    id: null,
    name: '',
    category: '',
    price: '',
    validity: '',
    warranty: '',
    specifications: '',
    image: null,
  });

  
const filteredProducts = products.filter((p) => {
  const q = searchQuery.toLowerCase();
  return (
    p.name.toLowerCase().includes(q) ||
    p.price.toString().includes(q) ||
    p.warranty.toLowerCase().includes(q)
  );
});

const currentProducts = filteredProducts.slice(indexOfFirstItem, indexOfLastItem);
const totalPages = Math.ceil(filteredProducts.length / itemsPerPage);

  const [showModal, setShowModal] = useState(false);

    const storedCategory = sessionStorage.getItem("business_category");
  console.log("Category", storedCategory)

  const fetchProducts = async () => {
    const res = await axios.get(`${baseURL}/${userId}`);
    setProducts(res.data);
  };

  useEffect(() => {
    if (userId) fetchProducts();
  }, [userId]);

  const handleChange = (e) => {
    const { name, value, files } = e.target;
    if (name === 'image') {
      setFormData({ ...formData, image: files[0] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const payload = new FormData();
    Object.entries(formData).forEach(([key, value]) => {
      if (value !== null) payload.append(key, value);
    });
    payload.append('user_id', userId);

    try {
      if (formData.id) {
        await axios.put(`${baseURL}/${formData.id}`, payload);
      } else {
        await axios.post(baseURL, payload);
      }

      setFormData({
        id: null,
        name: '',
        category: sessionStorage.getItem("business_category") || '',
        price: '',
        validity: '',
        warranty: '',
        specifications: '',
        image: null,
      });
      setShowModal(false);
      fetchProducts();
    } catch (error) {
      console.error('Upload failed:', error);
    }
  };

  const handleEdit = (product) => {
    setFormData({ ...product, image: null });
    setShowModal(true);
  };

const [isDataLoaded, setIsDataLoaded] = useState(false);

useEffect(() => {
  const storedCategory = sessionStorage.getItem("business_category");
  console.log("storedCategory",storedCategory)
  if (storedCategory) {
    setFormData((prev) => ({
      ...prev,
      category: storedCategory,
    }));
  }
  setIsDataLoaded(true);
}, []);

if (!isDataLoaded) return null; // or a loader

  return (
    <div style={{ padding: '20px', backgroundColor: '#fff' }}>
      <Card style={{ backgroundColor: '#062d59', color: '#fff', padding: '20px' }}>
        <h3>Manage Your Products</h3>
        <Button
          variant="light"
          onClick={() => {
            setFormData({
              id: null,
              name: '',
              category: sessionStorage.getItem("business_category") || '',
              price: '',
              validity: '',
              warranty: '',
              specifications: '',
              image: null,
            });
            setShowModal(true);
          }}
        >
          + Add Product
        </Button>
      </Card>

      <div className="d-flex justify-content-end align-items-end mt-4">
  <Form.Control
    type="text"
    placeholder="Search by name, price or warranty"
    value={searchQuery}
    onChange={(e) => {
      setSearchQuery(e.target.value);
      setCurrentPage(1); // Reset to page 1 on search
    }}
    style={{ maxWidth: '300px' }}
  />
</div>


      <Table striped bordered hover className="mt-4" responsive>
        <thead style={{ backgroundColor: '#e3080c', color: '#fff' }}>
          <tr>
            <th>Name</th>
            <th>Category</th>
            <th>Price</th>
            <th>Validity</th>
            <th>Warranty</th>
            <th>Specifications</th>
            <th>Image</th>
            <th>Action</th>
          </tr>
        </thead>
        <tbody>
 {currentProducts.map((p) => (
  <tr key={p.id}>
    <td>{p.name}</td>
    <td>{p.category}</td>
    <td>₹{p.price}</td>
    <td>{p.validity}</td>
    <td>{p.warranty}</td>
    <td>{p.specifications}</td>
    <td>
      <img
        src={p.image}
        alt="Product"
        style={{ width: 60, height: 60, objectFit: 'cover' }}
      />
    </td>
    <td>
      <FaEdit
        style={{ cursor: 'pointer', color: '#062d59' }}
        onClick={() => handleEdit(p)}
      />
    </td>
  </tr>
))}

        </tbody>
      </Table>
      <div className="d-flex justify-content-end mt-3">
  <Pagination>
    <Pagination.First onClick={() => setCurrentPage(1)} disabled={currentPage === 1} />
    <Pagination.Prev onClick={() => setCurrentPage((prev) => Math.max(prev - 1, 1))} disabled={currentPage === 1} />
    {[...Array(totalPages)].map((_, idx) => (
      <Pagination.Item
        key={idx + 1}
        active={currentPage === idx + 1}
        onClick={() => setCurrentPage(idx + 1)}
      >
        {idx + 1}
      </Pagination.Item>
    ))}
    <Pagination.Next onClick={() => setCurrentPage((prev) => Math.min(prev + 1, totalPages))} disabled={currentPage === totalPages} />
    <Pagination.Last onClick={() => setCurrentPage(totalPages)} disabled={currentPage === totalPages} />
  </Pagination>
</div>


    <Modal
  show={showModal}
  onHide={() => setShowModal(false)}
  size="lg"
  centered
  backdrop="static"
  style={{ zIndex: 9999 }}
>

        <Modal.Header closeButton style={{ backgroundColor: '#062d59', color: '#fff' }}>
          <Modal.Title>{formData.id ? 'Edit Product' : 'Add Product'}</Modal.Title>
        </Modal.Header>
        <Form onSubmit={handleSubmit} encType="multipart/form-data">
          <Modal.Body>
<Row className="g-3">
  <Col md={6}>
    <Form.Group>
      <Form.Label>Product Name</Form.Label>
      <Form.Control
        type="text"
        name="name"
        value={formData.name}
        onChange={handleChange}
        required
      />
    </Form.Group>
  </Col>
    <Col md={6}>
    <Form.Group>
      <Form.Label>Product Image</Form.Label>
      <Form.Control type="file" name="image" onChange={handleChange} />
    </Form.Group>
  </Col>
<Col md={6}>
  <Form.Group>
    <Form.Label>Category</Form.Label>
    <Form.Control
      type="text"
      name="category"
      value={formData.category}
      readOnly
    />
  </Form.Group>
</Col>

  <Col md={6}>
    <Form.Group>
      <Form.Label>Price (₹)</Form.Label>
      <Form.Control
        type="number"
        name="price"
        value={formData.price}
        onChange={handleChange}
        required
      />
    </Form.Group>
  </Col>
<Col md={6}>
  <Form.Group>
    <Form.Label>Validity</Form.Label>
  <div style={{ width: '100%' }}>
  <DatePicker
  selected={formData.validity ? new Date(formData.validity) : null}
  onChange={(date) =>
    setFormData({
      ...formData,
      validity: date ? date.toISOString().split('T')[0] : '',
    })
  }
  dateFormat="dd-MM-yyyy"
  placeholderText="Select a date"
  className="form-control"
    wrapperClassName="w-100"
/>

</div>

  </Form.Group>
</Col>

  <Col md={6}>
    <Form.Group>
      <Form.Label>Warranty</Form.Label>
      <Form.Control
        type="text"
        name="warranty"
        value={formData.warranty}
        onChange={handleChange}
      />
    </Form.Group>
  </Col>
  <Col md={8}>
    <Form.Group>
      <Form.Label>Specifications</Form.Label>
      <Form.Control
        as="textarea"
        rows={3}
        name="specifications"
        value={formData.specifications}
        onChange={handleChange}
      />
    </Form.Group>
  </Col>

</Row>

          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={() => setShowModal(false)}>
              Cancel
            </Button>
            <Button variant="danger" type="submit">
              {formData.id ? 'Update' : 'Upload'}
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Products;
